import {
  createListenerMiddleware,
  PayloadAction,
  ThunkDispatch,
} from '@reduxjs/toolkit';
import { type CountryCode } from 'libphonenumber-js';
import { configurePhoneUtils } from '@rsos/utils/internationalPhoneNumberUtils';
import type { PSAPInfo, StateWithPsaps } from './psapInfo.types';
import { fetchPsap, selectPSAPCountryAlpha2 } from './psapInfoSlice';

export const psapInfoListener = createListenerMiddleware<
  StateWithPsaps,
  ThunkDispatch<
    StateWithPsaps,
    StateWithPsaps,
    PayloadAction<PSAPInfo | string>
  >
>();

psapInfoListener.startListening({
  actionCreator: fetchPsap.fulfilled,
  effect: (_action, { getState }) => {
    const alpha2 = selectPSAPCountryAlpha2(getState());
    configurePhoneUtils(alpha2 as CountryCode);
  },
});
